import * as L from 'leaflet';

import { MapFeature } from './map-feature';
import { MapObject } from './map-object';

/** Optional object-detail capability, independent of selection. */
export interface PopoverFeature<TObject extends MapObject = MapObject>
extends MapFeature<TObject> {
  /** Allows feature-owned object clicks to present details. */
  enablePopovers(): void;
  /** Blocks new inspection and removes native bindings; persistent Focus may remain. */
  disablePopovers(): void;
  /** Resolves a click on a non-Leaflet surface, such as a canvas Grid cell. */
  showPopoverAt?(latlng: L.LatLng): void;
}

/** Narrows a registered feature without requiring selection methods. */
export function isPopoverFeature(feature: MapFeature): feature is PopoverFeature {
  const candidate = feature as Partial<PopoverFeature>;
  return typeof candidate.enablePopovers === 'function'
    && typeof candidate.disablePopovers === 'function';
}
